import { loadResourcesUtils } from '@ane/core/lib/utils/LoadResourcesUtils';
import { getDefaultAsyncWrapperObj } from '@ane/core/lib/models';
import { createAction } from 'typesafe-actions';
import NotificationSettingResource from '@ane/exp-data/lib/resources/NotificationSettingResource';
export const defaultReducerState = getDefaultAsyncWrapperObj();
const actionPrefix = 'PutNotificationSetting';
const putNotificationSettingDetailEpicReducerArg = {
    actionPrefix: actionPrefix,
    reduxKeyNested: () => ['value'],
    loadResource: (request) => NotificationSettingResource.putNotificationSetting(request.workspaceId, request.id, request.notificationSubscriptionConfig),
    onCompleteSuccess: (resourcesResult) => resourcesResult,
};
export const putNotificationSettingEpicReducer = loadResourcesUtils(putNotificationSettingDetailEpicReducerArg);
export const putNotificationSettingStateDefault = {
    value: getDefaultAsyncWrapperObj(),
};
// Reducer
export const PutNotificationSettingReducer = (state = putNotificationSettingStateDefault, action) => {
    state = putNotificationSettingEpicReducer.reduxChange(state, action);
    return state;
};
export const resetPutResult = createAction(`${actionPrefix}/RESET`);
export default PutNotificationSettingReducer;

//# sourceMappingURL=PutNotificationSetting.ducks.js.map
